module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_daisi-38c843ef9595d4b14615504627b384ae.jpg";